import { apiRequest } from 'src/utils/api-request';

export const resendVerificationEmail = () =>
  apiRequest({
    path: '/me/verify',
    method: 'POST',
    body: {},
  });
